import { COP_COMMON_ERROR_MESSAGES } from '../../../constants/common-error-messages'
import { get } from '../../../services/http.service'
import { type CustomerODataResponse, fetchCustomersData } from '../../../services/customerSearch.service'
import { ToastService } from '../../../services/toast.service'

export type AccountItem = {
    id: string
    name: string
    slaState: string
}

export type UserAccountData = CustomerODataResponse<AccountItem>

export async function fetchUserAccountData(searchTerm?: string, skip = 0): Promise<UserAccountData | null> {
    try {
        return await fetchCustomersData<AccountItem>({
            cacheKeyPrefix: 'userAccountData',
            searchTerm,
            skip,
            top: 50,
        })
    } catch (error) {
        console.error('[CopUserAccount] Failed to fetch user account data:', error)
        return null
    }
}

export async function submitAccountSelection(
    selectionApiUrl: string,
    accountId: string,
): Promise<boolean> {
    if (!selectionApiUrl || !accountId) return false
    try {
        const url = `${selectionApiUrl}${selectionApiUrl.includes('?') ? '&' : '?'}accountId=${encodeURIComponent(accountId)}`
        await get(url)
        return true
    } catch (error) {
        const fallbackMessage = COP_COMMON_ERROR_MESSAGES['api-error'].message.replace(
            '{{action}}',
            COP_COMMON_ERROR_MESSAGES['api-error'].action['user-account-selection-submitting'],
        )
        const message = error instanceof Error && error.message ? error.message : fallbackMessage
        ToastService.error(message)
        return false
    }
}

